export default __webpack_public_path__ + "static/media/Helm of the Wicked.18df9cd7.jpg";